<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill_data_filter`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.98633 1.53906C11.6889 1.53906 14.68 2.70952 14.6816 4.5625C14.6816 5.01515 14.5035 5.44608 14.1787 5.83984C14.1568 5.86677 14.1343 5.89495 14.1074 5.92188L14.0791 5.95117C14.0118 6.02514 13.9389 6.0954 13.8633 6.16602L9.65137 10.3789V13.4268C9.65131 14.0444 8.90022 14.5439 7.97461 14.5439C7.04746 14.5438 6.29888 14.0443 6.29883 13.4268V10.374L2.13867 6.21289C1.58667 5.72483 1.26953 5.15968 1.26953 4.56055C1.26966 2.70935 4.28388 1.53909 7.98633 1.53906ZM7.97559 2.34277C5.06042 2.34282 2.69727 3.29703 2.69727 4.47363C2.69777 5.65006 5.06073 6.60347 7.97559 6.60352C10.8905 6.60352 13.2534 5.65009 13.2539 4.47363C13.2539 3.29701 10.8908 2.34277 7.97559 2.34277Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillDataFilter',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
